import React from "react"
import classnames from "classnames"
import DatePicker from "@infotech/uikit-datepicker"
import styles from "./styles.css"

export default ({
  input: { value, onChange, name },
  meta: { error },
  withTime,
  typeOfDuration,
  duration,
  durationError,
  endDateTime,
  isDisabled,
}) => (
  <div>
    <DatePicker
      onChange={val => onChange(val.getTime())}
      name={name}
      typeOfDuration={typeOfDuration}
      duration={duration}
      endDateTime={endDateTime}
      value={new Date(value)}
      withTime={withTime}
      className={classnames(styles[`date-time-picker`], {
        [styles[`red-border`]]: error,
      })}
      disabled={isDisabled}
    />
    {typeOfDuration !== `createEvent` ||
    error ||
    // Here we need to toggle place for errors in Calendar, when we create Event
    (typeOfDuration === `createEvent` &&
      name === `startDateTime` &&
      !durationError) ? (
      <div className={styles[`input-error`]}>{error}</div>
    ) : null}
  </div>
)
